<div class="grid grid-cols-12 gap-4">
  <div class="col-span-12">
    <div class="p-form-widget p-form-view-data col-span-12">
      <div class="field">
        <label class="font-interruption label-width">Review Period:</label>
        <div class="p-field-value">
          <div class="readonly-field">
            <span>B - {{reviewPeriodB.startDate | date: 'MM/dd/yyyy'}} - {{reviewPeriodB.endDate | date: 'MM/dd/yyyy'}}</span>
          </div>
        </div>
      </div>

      <div class="field items-baseline">
        <label class="font-interruption label-width">Skill:</label>
        <div class="p-field pl-4">
          @for (skill of skills; track skill; let i = $index) {
            <div class="pb-4">
              <div class="flex items-center">
                <p-radio-button
                  name="skill"
                  [inputId]="'skill_' + i"
                  [value]="skill"
                  [formControl]="skillControl"
                />
                <label [for]="'skill_' + i" class="ml-2">{{ skill | skillCode }}</label>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>

<footer role="none" class="flex justify-end">
  <button
    type="button"
    pButton
    label="Cancel"
    class="p-button-secondary mr-2"
    (click)="cancel()"
  ></button>
  <button
    type="button"
    pButton
    label="Next"
    [disabled]="skillControl.invalid"
    (click)="next()"
  ></button>
</footer>
